import React, { VFC } from 'react';
import { Box, makeStyles } from '@dxb-web-ui-framework/design-system';
import { GenericDrawer } from '../../../content-composer/src/components/Generic/GenericDrawer';
import { ECOMMBXLoader } from '../../..//content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';
import { ApproveRejectAuthFlowPresenter } from './ApproveRejectAuthFlowPresenter';

export interface ApproveRejectAuthDrawerProps {
  isOpen: boolean;
  onToggle: () => void;
  authAction: string | null;
  isBulk: boolean;
  showMandateInfoRateButton?: boolean;
}

const useStyles = makeStyles(theme => ({
  drawerBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
}));

const ApproveRejectAuthDrawer: VFC<ApproveRejectAuthDrawerProps> = ({
  isOpen,
  onToggle,
  authAction,
  isBulk,
  showMandateInfoRateButton,
}) => {
  const classes = useStyles();

  if (!authAction) {
    return null;
  }

  return (
    <GenericDrawer
      anchor='bottom'
      title=''
      isOpen={isOpen}
      stickDrawerTitleToLeft
      disableMobileDrawerHeight
      onToggleDrawer={onToggle}
      customDrawerBodyClass={classes.drawerBodyContainer}>
      {showMandateInfoRateButton === undefined && !Boolean(isBulk) ? (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
          <ECOMMBXLoader size='small' />
        </Box>
      ) : (
        <ApproveRejectAuthFlowPresenter authAction={authAction} onToggleDrawer={onToggle} isBulk={isBulk} />
      )}
    </GenericDrawer>
  );
};

export { ApproveRejectAuthDrawer };
